<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import LaisErrorState from 'dashboard/components-next/LaisErrorState.vue';
import LaisPermissionState from 'dashboard/components-next/LaisPermissionState.vue';

defineProps({
  canViewOperations: { type: Boolean, default: true },
  hasOperationError: { type: Boolean, default: false },
  errorMessage: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  hasNoOperationalData: { type: Boolean, default: false },
  banners: { type: Array, default: () => [] },
});

const emit = defineEmits(['retry']);
</script>

<template>
  <LaisPermissionState
    v-if="!canViewOperations"
    variant="denied"
    title="Operação indisponível"
    description="Permissão operacional necessária."
  />

  <section
    v-else-if="hasOperationError && !loading"
    class="grid gap-4"
    aria-label="Cockpit operacional de pendentes"
  >
    <LaisErrorState
      data-test="pending-market-operation-error-state"
      title="Falha ao carregar operação"
      :description="errorMessage"
      show-action
      action-label="Recarregar operação"
      @action="emit('retry')"
    />
  </section>

  <section
    v-else-if="hasNoOperationalData"
    class="grid min-h-[320px] place-items-center rounded-lais border border-dashed border-lais-border-soft bg-lais-bg-card p-6 text-center text-lais-text shadow-lais-card"
    role="status"
    data-test="pending-market-operation-empty-state"
    aria-label="Cockpit operacional de pendentes"
  >
    <div class="max-w-lg">
      <span
        class="mx-auto grid size-14 place-items-center rounded-full bg-lais-bg-soft text-lais-text-muted"
        aria-hidden="true"
      >
        <span class="i-lucide-inbox size-6" />
      </span>
      <h2 class="mt-3 font-redHatDisplay text-lais-heading-sm font-semibold">
        Nenhum sinal operacional no filtro
      </h2>
      <p class="mt-2 text-lais-body-sm text-lais-text-muted">
        Nao ha filas, grupos, runs ou itens para o recorte atual. Ajuste o tipo
        de pendente ou recarregue quando houver um novo processamento.
      </p>
    </div>
  </section>

  <section
    v-else
    aria-label="Cockpit operacional de pendentes"
    class="grid gap-4"
  >
    <div
      v-if="banners.length"
      class="grid gap-3"
      data-test="pending-market-operation-partial-stale-state"
    >
      <article
        v-for="banner in banners"
        :key="banner.key"
        class="rounded-lais border border-amber-200 bg-amber-50 px-4 py-3 text-amber-800"
        :data-state="banner.key"
      >
        <div class="flex gap-2">
          <span
            class="mt-0.5 size-4 shrink-0"
            :class="banner.icon"
            aria-hidden="true"
          />
          <div class="min-w-0">
            <p class="text-lais-body-sm font-semibold">{{ banner.title }}</p>
            <p class="mt-1 text-lais-body-xs leading-relaxed">
              {{ banner.description }}
            </p>
          </div>
        </div>
      </article>
    </div>

    <slot />
  </section>
</template>
